import pinConversations from './pinConversations';
import pinItems from './pinItems';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
/**
 * Toggle the row pinned status
 * @param rowKey row key to pin/unpin
 * @param tableViewId of the table that the row belong to
 * @param actionSource the action source
 */
export default function toggleRowPinnedState(rowKey, tableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var isRowPinned = MailRowDataPropertyGetter.getIsPinned(rowKey, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            pinConversations([rowKey], tableView, !isRowPinned, actionSource);
            break;
        case 1 /* Message */:
            pinItems([rowKey], tableView, !isRowPinned, actionSource);
            break;
    }
}
//# sourceMappingURL=toggleRowPinnedState.js.map